import { COLORS as COLORS_OLD } from '@r1-frontend/ui-react/assets/js/constants';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import React from 'react';
import styled from 'styled-components';

const DescriptionContainer = styled.section`
    background-color: ${COLORS_OLD.lightGrey};
    display: block;
    padding: 47px 0 44px;
    width: 100%;

    @media only screen and (max-width: 1359px) {
        padding-top: 31px;
    }
`;

const DescriptionWrapper = styled.div`
    box-sizing: border-box;
    display: block;
    margin: 0 auto;
    max-width: 1440px;
    padding: 0 7%;
    width: 100%;

    @media screen and (max-width: 859px) {
        padding: 0 15px;
        width: 100%;
    }
`;

const DescriptionHeader = styled.div`
    display: flex;
    width: 100%;

    @media only screen and (max-width: 767px) {
        flex-direction: column;
    }
`;

const DescriptionHeaderTitle = styled.h1`
    color: ${COLORS.TextPrimary};
    display: block;
    ${FONTS.H1};
    margin: -5px 0 0 0;

    @media only screen and (max-width: 1359px) {
        ${FONTS.H2};
    }

    @media only screen and (max-width: 1023px) {
        ${FONTS.H2};
    }

    @media only screen and (max-width: 767px) {
        ${FONTS.H2};
        margin-top: 0;
    }
`;

const DescriptionHeaderNumber = styled.div`
    color: ${COLORS_OLD.darkGrey};
    ${FONTS.S};
    margin-bottom: -3px;

    @media only screen and (max-width: 767px) {
        margin-bottom: 0;
        margin-top: 10px;
    }
`;

const DescriptionHeaderPicture = styled.picture`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    height: 67px;
    width: 100px;
`;

const DescriptionHeaderImage = styled.img`
    max-height: 90%;
    max-width: 90%;
`;

const DescriptionHeaderContent = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 28px;

    @media only screen and (max-width: 767px) {
        justify-content: flex-start;
        margin-left: 0;
        margin-top: 16px;
    }
`;

const DescriptionBody = styled.div`
    color: ${COLORS.TextPrimary};
    display: block;
    ${FONTS.S};
    margin-top: 30px;
    width: 100%;

    @media only screen and (max-width: 767px) {
        margin-top: 13px;
    }

    p {
        margin: 0;
    }
`;

const DescriptionFooter = styled.div`
    display: block;
    margin-top: 24px;
    width: 100%;
`;

const DescriptionFooterTitle = styled.div`
    color: ${COLORS.TextPrimary};
    display: block;
    ${FONTS.S};
    width: 100%;
`;

const DescriptionFooterList = styled.ul`
    display: block;
    list-style-type: none;
    margin: 9px 0 0 0;
    padding: 0;
`;

const DescriptionFooterListItem = styled.li`
    display: inline-block;

    &::after {
        color: ${COLORS_OLD.blue};
        content: ", ";
        white-space: pre;
    }

    &:last-child {
        &::after {
            content: none;
        }
    }
`;

const DescriptionFooterListHref = styled.a`
    color: ${COLORS_OLD.blue};
    ${FONTS.S};
    text-decoration: underline;
`;

export default function DescriptionDetail(props) {
    const description = props.channelInfo.description;

    const packageList = props.packageList.map((pack) => {
        return (
            <DescriptionFooterListItem key={pack.id}>
                <DescriptionFooterListHref href={pack.alias}>{pack.title}</DescriptionFooterListHref>
            </DescriptionFooterListItem>
        );
    });

    let descriptionFooter = null;
    if (props.packageList.length > 0) {
        descriptionFooter = (
            <DescriptionFooter>
                <DescriptionFooterTitle>Канал входит в пакеты:</DescriptionFooterTitle>
                <DescriptionFooterList>{packageList}</DescriptionFooterList>
            </DescriptionFooter>
        );
    }
        return (
            <DescriptionContainer>
                <DescriptionWrapper>
                    <DescriptionHeader>
                        <DescriptionHeaderPicture>
                            <DescriptionHeaderImage
                                src={props.channelInfo.channelInfo.logo}
                                alt={props.channelInfo.channelInfo.title}
                            />
                        </DescriptionHeaderPicture>
                        <DescriptionHeaderContent>
                            <DescriptionHeaderTitle>
                                {props.channelInfo.channelInfo.title}
                            </DescriptionHeaderTitle>
                            <DescriptionHeaderNumber>
                                Кнопка №{props.channelInfo.button}
                            </DescriptionHeaderNumber>
                        </DescriptionHeaderContent>
                    </DescriptionHeader>
                    <DescriptionBody>
                        {description}
                    </DescriptionBody>
                    {descriptionFooter}
                </DescriptionWrapper>
            </DescriptionContainer>
        );
}
